// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1bSzn","title":"Header_title__3CBU5","side":"Header_side__3ktQI"};